<p-blockUI [blocked]="working" baseZIndex="9999">
    <ng-template pTemplate="content">
        <em class="fal fa-hourglass fa-spin fa-3x app-spinner"></em>
        <section>Loading..</section>
    </ng-template>
</p-blockUI>
<div class="tw-flex tw-w-full tw-h-full tw-flex-col tw-pb-4">
    <div class="scroll-container tw-mb-4 tw-mt-4 tw-pl-8 tw-pr-8">
        <div class="scroll-content tw-pl-8 tw-pr-8">
            <p-table #dt *ngIf="apps" dataKey="id" [value]="apps" [scrollable]="true" scrollHeight="flex"
                [resizableColumns]="true" [globalFilterFields]="['state', 'hContract', 'fileName']" stateStorage="local"
                [stateKey]="dtIngestion" selectionMode="multiple" [(selection)]="selectedApprovals"
                sortField="ThreatLevel" [sortOrder]="1" class="tw-h-full">
                <ng-template pTemplate="caption">
                    <ng-container *ngTemplateOutlet="toolbarTemplate"></ng-container>
                </ng-template>
                <ng-template pTemplate="header" let-columns>
                    <tr>
                        <th style="width: 4rem"></th>
                        <th style="width: 10%" pResizableColumn pSortableColumn="state">State
                            <p-sortIcon field="state"></p-sortIcon>
                        </th>
                        <th style="width: 10%" pResizableColumn pSortableColumn="hContract">H Contract
                            <p-sortIcon field="hContract"></p-sortIcon>
                        </th>
                        <th style="width: 15%" pResizableColumn pSortableColumn="fileGenerationDate">File Generated
                            <p-sortIcon field="fileGenerationDate"></p-sortIcon>
                        </th>
                        <th pResizableColumn>
                            Rejection Criteria
                        </th>
                        <th style="width: 8rem" pSortableColumn="ThreatLevel" class="tw-text-right"
                            pTooltip="Sort on Threat Level">
                            <p-sortIcon field="ThreatLevel"></p-sortIcon>
                        </th>
                    </tr>
                    <tr>
                        <th style="width: 4rem"><p-tableHeaderCheckbox></p-tableHeaderCheckbox></th>
                        <th style="width: 10%">
                            <p-columnFilter field="state" matchMode="equals" [showMenu]="false">
                                <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                                    <p-dropdown [ngModel]="value" [options]="this.states"
                                        (onChange)="filter($event.value)" placeholder="Select One" [showClear]="true"
                                        appendTo="body">
                                    </p-dropdown>
                                </ng-template>
                            </p-columnFilter>
                        </th>
                        <th style="width: 10%">
                            <p-columnFilter field="hContract" matchMode="equals" [showMenu]="false">
                                <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                                    <p-dropdown [ngModel]="value" [options]="this.hContracts"
                                        (onChange)="filter($event.value)" placeholder="Select One" [showClear]="true"
                                        appendTo="body">
                                    </p-dropdown>
                                </ng-template>
                            </p-columnFilter>
                        </th>
                        <th style="width: 15%"></th>
                        <th>
                            <ng-container *ngIf="selectedApprovals.length > 0">
                                <div class="tw-grid tw-grid-cols-4">
                                    <div class="tw-col-span-3 tw-mr-1 tw-align-middle">
                                        <div class="tw-flex tw-w-full">
                                            <p-chips [(ngModel)]="rejectionChips" class="ng-dirty tw-w-full tw-flex"
                                                styleClass="tw-w-full tw-items-stretch tw-flex tw-flex-col"
                                                inputStyleClass="tw-w-full"
                                                pTooltip="Type a date, and press Enter to create a Medicaid End Date rejection."></p-chips>
                                        </div>
                                    </div>
                                    <div class="tw-col-span-1 tw-align-middle" style="padding-top: 2px;">
                                        <button pButton label="Apply" class="p-button-outlined tw-mr-4"
                                            icon="pi pi-check" [disabled]="selectedApprovals.length == 0"
                                            (click)="applyRejectionCriteria()"
                                            pTooltip="Apply the criteria to the highlighted rows."></button>
                                    </div>
                                </div>
                            </ng-container>
                        </th>
                        <th style="width: 8rem"></th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-approval>
                    <tr [pSelectableRow]="approval">
                        <td></td>
                        <td>{{ approval.state }}</td>
                        <td>{{ approval.hContract }}</td>
                        <!--  <td>{{ approval.fileName }}</td> -->
                        <td>{{ approval.generated | date : 'MM/dd/yyyy hh:mm a' }}</td>
                        <td>
                            <ng-container *ngIf="approval.editMode">
                                <p-chips [(ngModel)]="approval.RejectionChipsArray" class="ng-dirty tw-w-full"
                                    styleClass="tw-w-full tw-items-stretch tw-flex tw-flex-col"
                                    inputStyleClass="tw-w-full"
                                    pToolTip="Type and press Enter to create an entry."></p-chips>
                            </ng-container>
                            <ng-container *ngIf="!approval.editMode">
                                <p-chip *ngFor="let c of approval.RejectionCriteria"
                                    class="custom-chip outlined info tw-text-gray-500 tw-text-xs"
                                    [label]="c.Value"></p-chip>
                            </ng-container>
                        </td>
                        <td>
                            <ng-container *ngIf="approval.editMode">
                                <button pButton pRipple type="button" icon="fal fa-save" (click)="acceptEdit(approval)"
                                    class="p-button-rounded tw-mr-1" pTooltip="Save" tooltipPosition="top"></button>
                                <button pButton pRipple type="button" icon="fal fa-cancel"
                                    (click)="cancelEdit(approval)"
                                    class="p-button-rounded p-button-warning p-button-outlined" pTooltip="Cancel"
                                    tooltipPosition="top"></button>
                            </ng-container>
                            <ng-container *ngIf="!approval.editMode">
                                <button pButton pRipple type="button" icon="fal fa-pencil"
                                    (click)="requestEdit(approval)" class="p-button-rounded p-button-success tw-mr-1"
                                    pTooltip="Edit Rejection Criteria" tooltipPosition="top"></button>
                            </ng-container>
                            <app-ingestion-item-detail [approvalItem]="approval"
                                [multiplier]="threshold"></app-ingestion-item-detail>
                        </td>
                    </tr>
                </ng-template>
            </p-table>
        </div>
    </div>
</div>

<ng-template #toolbarTemplate>
    <p-toolbar>
        <div class="p-toolbar-group-left tw-ml-4 tw-mr-4">
        </div>
        <div class="p-toolbar-group-center tw-ml-4 tw-mr-4">
        </div>
        <div class="p-toolbar-group-right tw-w-1/2 tw-justify-end">
            <span class="tw-mr-1"><b>Threshold Multiplier :</b></span>
            <span class="p-input-icon-left tw-mr-4">
                <i class="fa fa-gauge fa-light"></i>
                <input type="number" class="p-inputtext p-component tw-w-24" [(ngModel)]="threshold"
                    pTooltip="Standard Deviation Threshold (for level red)" (change)="thresholdChanged()" />
            </span>
            <ng-container *ngIf="this.service.userHasIngestionApprovalEditPermissions">
                <button pButton label="Approve" class="p-button-outlined tw-mr-4" icon="pi pi-check"
                    [disabled]="selectedApprovals.length == 0" (click)="approve()"
                    pTooltip="Approve the Selected record(s)">
                </button>
                <button pButton label="Reject" class="p-button-outlined tw-mr-4" icon="pi pi-times"
                    [disabled]="selectedApprovals.length == 0" (click)="reject()"
                    pTooltip="Reject the Selected record(s)">
                </button>
            </ng-container>
        </div>
    </p-toolbar>
</ng-template>
